// extracted by mini-css-extract-plugin
export default {"Rate":"CandidateVideosRate_Rate__D7qOj"};